<template>
  <div class="time-table">
    <div><span class="station-type" v-if="showTimetableDisplayName">{{displayName}}</span> <span v-if="(showDistance && distance) && distance.type && distance.displayTime" :class="['distance', 'icon', {[this.distance.type]: true }]">{{distance. displayTime}}</span></div>
    <h2>
      {{stationName}}
      <dot v-if="color" :color="color" />
    </h2>
    <table>
      <thead>
        <tr>
          <th :class="{icon: true, [type]: true }"></th>
          <th>{{destinationHeading}}</th>
          <th>{{departureHeading}}</th>
        </tr>
      </thead>
      <transition-group name="list" tag="tbody">
        <template v-for="journey in this.journeys">
          <tr class="buggy-colspan-fix" :key="journey.StopPointNumber + '' + journey.JourneyNumber + '_fix'"><td></td><td></td><td></td></tr>
          <tr class="list-item" :key="journey.StopPointNumber + '' + journey.JourneyNumber">
            <template v-if="journey.LineNumber">
              <td>{{journey.LineNumber}}</td>
              <td v-html="journey.Destination"></td>
            </template>
            <template v-else>
                <td colspan="2" v-html="journey.Destination"></td>
            </template>
            <td>{{journey.DisplayTime}}</td>
          </tr>
        </template>
      </transition-group>
      <tfoot v-if="footerText">
        <tr>
          <td colspan="3">{{footerText}}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import Dot from './../Shared/Dot'

export default {
  props: {
    stationName: {
      type: String,
      required: true
    },
    showTimetableDisplayName: {
      type: Boolean,
      default: false
    },
    displayName: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: false
    },
    journeys: {
      type: Array
    },
    distance: {
      type: Object
    }, 
    showDistance: {
      type: Boolean,
      default: false
    },
    type: {
      type: String
    },
    destinationHeading: {
      type: String
    },
    departureHeading: {
      type: String
    },
    footerText: {
      type: String
    }
  },
  components: {
    Dot
  }
}
</script>

<style lang="scss">
  .time-table {
    font-size: 2rem;
    &+.time-table {
      margin-top: 2rem;
    }

    .station-type {  
      font-weight: 500;
      letter-spacing: 0.1em;
      line-height: 1em;
      text-transform: uppercase;
      //  font-family: ABeeZee;
      font-size: 18px;
    }

    .distance {
      background-position: bottom 0px left;
      display: inline-block;
      font-family: 'ABeeZee', sans-serif;
      font-size: 1.5rem;
      position: relative;
      letter-spacing: 0;
      margin-left: 1rem;
      padding-bottom: 0px;
      padding-left: 2rem;
    }

    h2 {
      font-family: 'Paytone One', sans-serif;
      font-size: 3.5rem;
      font-weight: 400;
      letter-spacing: 3px;
      line-height: 1;
      margin: 0 0 20px;
    }

    .icon {
      background-repeat: no-repeat;
      background-size: contain;
      &.bus {
        background-image: url('../../assets/bus.svg');
      }
      &.metro {
        background-image: url('../../assets/metro.svg');
      }
      &.train {
        background-image: url('../../assets/train.svg');
      }
      &.tram {
        background-image: url('../../assets/tram.svg');
      }
      &.walk {
        background-image: url('../../assets/walk.png');
      }
    }

    table {
      border-collapse: collapse;
      margin: 0 0 20px;
      text-align: left;
      position: relative;
      padding: 0;
      width: 100%;
      th {
        border-bottom: 2px solid rgba(255, 255, 255, 0.5);
        font-weight: 400;
        vertical-align: bottom;

        &.icon {
          background-position: bottom 1rem left 20px;
          background-repeat: no-repeat;
          background-size: 34px 34px;
        }
      }

      tr.buggy-colspan-fix th,
      tr.buggy-colspan-fix td {
        padding: 0;
        width: auto !important;
      }

      th, td {
        padding: 10px 20px;
        width: 65%;
        &:first-child {
          min-width: 40px;
          padding-right: 0;
          width: 10%;
        }
        &:last-child {
          width: 25%;
        }
      }
      td {
        color: #f3bc29;
      }

      tfoot td {
        color: white;
        font-size: 1.2rem;
        line-height: 1.8rem;
      }
    }

    .timetable-arrows {
      background: url('./../../assets/timetable-arrows.png') no-repeat;
      display: inline-block;
      margin: 0 8px -2px;
      width: 35px;
      height: 17px;
    }

    .list-item {
      transition: all 1s;
    }
    .list-enter, .list-leave-to {
      opacity: 0;
      transform: translateY(30px);
    }
    .list-leave-active {
      position: absolute;
    }

    // edge-case table..
    .wide-last-column & {
      table {
        th {
          width: 58%;
          &:first-child {
            width: 10%;
          }
          &:last-child {
            width: 32%;
          }
        }
        td {
          width: 68%;
          // &:first-child {
          //   width: 10%;
          // }
          &:last-child {
            width: 32%;
          }
        }
      }
    }

  }
</style>
